module.exports = __webpack_public_path__ + "img/backtop.1f8c3f0b.png";